import React from 'react';
import PropTypes from 'prop-types';
import { getCountryFromCountryCode } from '../form/CountryCodes';

const Address = props => {
  const { name, address1, address2, city, state, zip, countryCode, singleLine } = props;
  return (
    <address>
      {name && name}
      {name && !singleLine && <br />}
      {name && singleLine && <span>, </span>}
      {address1 && address1}
      {address1 && !singleLine && <br />}
      {address1 && singleLine && <span>, </span>}
      {address2 && address2}
      {address2 && !singleLine && <br />}
      {address2 && singleLine && <span>, </span>}
      {city && `${city}, `}
      {state && `${state} `}
      {zip && zip}
      {countryCode && !singleLine && <br />}
      {countryCode &&
        countryCode !== 'US' &&
        `${singleLine ? ', ' : ''}${getCountryFromCountryCode(countryCode)}`}
    </address>
  );
};

Address.propTypes = {
  name: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  countryCode: PropTypes.string,
  singleLine: PropTypes.bool,
};

export default Address;
